module.exports = __webpack_public_path__ + "img/SURVEY_HAPPINESS_SM.d78cdc8f.png";